import { Request } from 'commons/utils/request'
import { InvoiceSubmittalDetails } from '~bank-invoices/types/Details'

export const getInvoiceSubmittalDetails = (opts: { id: number }) =>
  Request.post<InvoiceSubmittalDetails, { id: number }>(Request.urls.bank.invoiceSubmittalDetails, opts)
